import sliceCreator from '../../index.jsx';
import {GET_ZONE_BY_ID} from '../../../constants/index.jsx';
const _getZoneByIdAction = sliceCreator('GET_ZONE_BY_ID', GET_ZONE_BY_ID, 'get');

const { asyncAction: getZoneByIdAction, reducer, clearData: clearGetZoneByIdAction } = _getZoneByIdAction;

export default reducer;

export {
    getZoneByIdAction,
    clearGetZoneByIdAction
}